// extracted by css-extract-rspack-plugin
export default {"wrapper":"_f0327c6b","iframe":"_ba272d6c _f0327c6b"};